/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Col, Row, Space, Input, Tabs, Badge, Tag } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  QuotationListReq,
  DeleteQuotationReq,
  QuotationData,
  CustomerQuotation,
  QuotationListData,
} from 'Store/quotation/types'
import { quotationListAPI, deleteQuotationAPI, getCountQuotationPI } from 'Store/quotation/api'
import {
  selectQuotationList,
  selectQuotationListEvent,
  selectQuotationActionEvent,
  selectQuotationCountData,
} from 'Store/quotation/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/quotation/actions'
import { clearEventAction as clearGrnEventAction } from 'Store/grn/actions'
import { formatDateTime, getQuotationStatus, numberWithComma, toDateQuery } from 'helpers/format'
import { FranchiseTag, StatusTag } from 'Components/utilities'
import { menuQuotationStatus, menuUserGroup, QuotationStatus } from 'helpers/constanst'
import { ConfirmDailog } from 'Components/modal'
import { TableListPage } from 'Components/common/Table'
import { ActionButton, PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import QuotationDetailForm from './form'
import QuotationDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import theme from 'Components/common/Theme'
import { RangeDateItem, SelectItem } from 'Components/form'
import { themeConfig } from 'config'
const { TabPane } = Tabs

type Props = {} & ReduxProps

const Quotation: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event, countData } = props
  const dispatch = useDispatch()
  const [drawer, setDrawer] = useState(false)
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')
  const isHQ = currentUser?.activeMerchant?.is_hq === true

  const [filter, setFilter] = useState({
    keyword: '',
    status: '',
    sort: 'desc',
    order_by: 'quotation_id',
    start_date: '',
    end_date: '',
    quotation_type: '',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: QuotationListReq = {
      keyword: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      sort: filter.sort || 'desc',
      order_by: filter.order_by || 'quotation_id',
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      quotation_type: filter.quotation_type,
    }
    if (filter.status) {
      req['status'] = filter.status
    }
    dispatch(quotationListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onCount = (): void => {
    dispatch(getCountQuotationPI({}, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  const onDelete = (id: number): void => {
    const req: DeleteQuotationReq = {
      id,
    }
    dispatch(deleteQuotationAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
      // onGetConfig()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  useEffect(() => {
    onCount()
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onOpenDrawer = () => {
    setDrawer(true)
  }

  const onCloseDrawer = () => {
    setDrawer(false)
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onOpenConfirmDelete = () => {
    setConfirmDeleteDialog(true)
  }

  const onCloseConfirmDelete = () => {
    setConfirmDeleteDialog(false)
  }

  const onClickCreate = () => {
    setPageMode('create')
    setSelectedID(0)
    onOpenDrawer()
  }

  const onClickEdit = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDrawer()
  }

  const onClickViewDetail = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const onClickDelete = (id: number) => {
    setPageMode('deleted')
    setSelectedID(id)
    onOpenConfirmDelete()
  }

  const onConfirmDelete = () => {
    onDelete(selectedID)
    onCloseConfirmDelete()
  }

  const onSuccess = () => {
    onCloseDrawer()
    onCloseDetailDrawer()
    onGetList()
    clearEvent()
    onCount()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
    dispatch(clearGrnEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const renderStatus = (status: string) => {
    const statusResult = getQuotationStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const renderActionButton = (text: string, record: QuotationData) => {
    const isEditable = record.status === QuotationStatus.DRAFT
    //const isEditable = true
    const isDeletable = record.status === QuotationStatus.DRAFT
    return (
      <Space size="middle">
        {isEditable && (
          <ActionButton
            text=""
            icon={<EditOutlined />}
            label="แก้ไข"
            action="edit"
            onClick={() => onClickEdit(record.quotation_id)}
          />
        )
        // : (
        //   <ActionButton
        //     text=""
        //     icon={<FileTextOutlined />}
        //     label="ตรวจสอบ"
        //     action="edit"
        //     onClick={() => onClickViewDetail(record.id)}
        //   />
        // )
        }
        {isDeletable && (
          <ActionButton
            text=""
            icon={<DeleteOutlined />}
            label="ลบ"
            action="deleted"
            onClick={() => onClickDelete(record.quotation_id)}
          />
        )}
      </Space>
    )
  }

  const renderName = (name: string, record: QuotationListData) => {
    const isFranchise = record?.quotation_type === 'franchise'
    return <FranchiseTag text={name} isFranchise={isFranchise} />
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'row_num',
      key: 'row_num',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เลขที่ใบเสนอราคา',
      dataIndex: 'quotation_no',
      key: 'quotation_no',
      width: '180px',
      render: (val: string, record: QuotationListData) => (
        <LinkNo onClick={() => onClickViewDetail(record.quotation_id)}>{val}</LinkNo>
      ),
      sorter: true,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
      render: renderName,
    },
    {
      title: <TextRight>จำนวน/รายการ</TextRight>,
      dataIndex: 'total_quantity',
      key: 'total_quantity',
      render: (value: any) => {
        return <TextRight>{numberWithComma(value)}</TextRight>
      },
      sorter: true,
    },
    {
      title: <TextRight>ราคารวม</TextRight>,
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (value: any) => {
        return <TextRight>{numberWithComma(value, true)}</TextRight>
      },
      sorter: true,
    },
    {
      title: 'วันที่ออกใบเสนอราคา',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value: any) => {
        return formatDateTime(value)
      },
      sorter: true,
    },
    {
      title: 'สถานะใบเสนอราคา',
      key: 'status',
      dataIndex: 'status',
      render: renderStatus,
      sorter: true,
    },
    {
      title: 'แก้ไข/ลบ',
      key: 'action',
      render: renderActionButton,
    },
  ]

  const DetailFormDrawer = (
    <QuotationDetailForm
      mode={pageMode}
      id={selectedID}
      visible={drawer}
      onCloseDrawer={onCloseDrawer}
      onSuccess={onSuccess}
    />
  )

  const DetailDrawer = (
    <QuotationDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={onSuccess}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={onCloseConfirmDelete}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={20}>
          <Row gutter={[8, 8]}>
            <Col xs={24} md={7}>
              <SearchInput
                placeholder="ค้นหาเลขที่ใบเสนอราคา, ชื่อลูกค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            {isHQ && (
              <Col xs={24} md={7}>
                <SelectItem
                  name={'quotation_type'}
                  label={''}
                  isRequired={true}
                  value={filter.quotation_type}
                  menu={menuUserGroup}
                  placeHolder={'กลุ่มลูกค้า'}
                  onChange={(val: any): void => onFilter('quotation_type', val)}
                  allowClear={true}
                />
              </Col>
            )}
            <Col xs={24} md={7}>
              <RangeDateItem
                placeHolder={['วันที่สร้างเริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
        <MyCol>
          <Space size="middle">
            <PrimaryButton text="ออกใบเสนอราคา" icon={<PlusOutlined />} onClick={onClickCreate} />
          </Space>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const onChangeTab = (key: string) => {
    onFilter('status', key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const renderTitle = (name: string, key: string) => {
    const newcountData = countData as any
    const count = newcountData?.[key || 'all'] || 0
    // const count = 0
    return (
      <span>
        {name} <Badge count={count} showZero={false} overflowCount={9999} />
      </span>
    )
  }

  const getTab = () => {
    return (
      <StickyHeader>
        <Tabs onChange={onChangeTab} activeKey={filter.status} type="line">
          {menuQuotationStatus.map((item: any) => {
            return <TabPane tab={renderTitle(item.name, item.value)} key={item.value}></TabPane>
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  return (
    <>
      <HomePageLayout selected="quotation" title="ใบเสนอราคา" label="">
        {getTab()}
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          size="middle"
          offsetHeader={25}
          rowKey="quotation_id"
          onSort={(field: string, order: string) => {
            onSort(field, order)
          }}
        />
        {LoadingModal}
        {DetailFormDrawer}
        {DetailDrawer}
        {ConfirmDeleteModal}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectQuotationList(state),
    listEvent: selectQuotationListEvent(state),
    event: selectQuotationActionEvent(state),
    countData: selectQuotationCountData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`
const TextRight = styled.div`
  text-align: right;
  margin-right: 20px;
`

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

export default connect(mapStateToProps)(Quotation)
